function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".volume-cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Calque_2",
  "data-name": "Calque 2"
}, React.createElement("g", {
  id: "Contenu"
}, React.createElement("line", {
  className: "volume-cls-1",
  x1: 1,
  y1: 8,
  x2: 1,
  y2: 10
}), React.createElement("line", {
  className: "volume-cls-1",
  x1: 6,
  y1: 6,
  x2: 6,
  y2: 12
}), React.createElement("line", {
  className: "volume-cls-1",
  x1: 11,
  y1: 3,
  x2: 11,
  y2: 14
}), React.createElement("line", {
  className: "volume-cls-1",
  x1: 16,
  y1: 1,
  x2: 16,
  y2: 17
}), React.createElement("line", {
  className: "volume-cls-1",
  x1: 21,
  y1: 4,
  x2: 21,
  y2: 14
}), React.createElement("line", {
  className: "volume-cls-1",
  x1: 26,
  y1: 6,
  x2: 26,
  y2: 12
}), React.createElement("line", {
  className: "volume-cls-1",
  x1: 31,
  y1: 8,
  x2: 31,
  y2: 10
})));

var SvgVolume = function SvgVolume(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 32 18",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVolume, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/volume.4a7ad9ef.svg";
export { ForwardRef as ReactComponent };